import React, { useEffect, useState } from 'react';
import API from '../utils/api';

// Weekly family insights for the dashboard — what the kids loved, what
// they're exploring, and how much the family read together. Renders nothing
// until there's real data behind at least one insight.
const InsightsCard = () => {
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    API.get('/users/insights')
      .then(res => setInsights(res.data.insights))
      .catch(() => {}); // card simply doesn't render
  }, []);

  if (!insights || insights.length === 0) return null;

  return (
    <div className="rounded-4 p-4 mb-4" style={{background:'var(--card-bg)', border:'1px solid var(--border-purple)'}}>
      <div className="fw-bold mb-3" style={{color:'var(--text-main)', fontSize:'17px', fontFamily:"'Fredoka One',cursive"}}>
        📊 This week with your family
      </div>
      <div className="d-flex flex-column gap-2">
        {insights.map(ins => (
          <div key={ins.id} className="d-flex align-items-start gap-3 p-3 rounded-3" style={{background:'var(--item-bg)'}}>
            <span style={{fontSize:'20px', lineHeight:1.3, flexShrink:0}}>{ins.emoji}</span>
            <span style={{color:'var(--text-body)', fontSize:'14px', lineHeight:1.6}}>{ins.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsCard;
